import { render, staticRenderFns } from "./ResourceBookmark.vue?vue&type=template&id=6f85050e"
import script from "./ResourceBookmark.ts?vue&type=script&lang=ts&external"
export * from "./ResourceBookmark.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports